angular.module('taric.model.certificate', ['ngResource', 'common.config']).factory('QueryCertificate', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/cert/certificates', {}, {
        queryCertificates: {
            method: 'GET',
            isArray: false
        },
        queryCertificateTypes : {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/cert/certificateTypes'
        }
    });
}).service('CertificateLookupModel', function($q, $translate, QueryCertificate, CommonHelper, CONSTANTS){
    var model = this,
        searchCriteria = {},
        searchResult = null;
    model.getSearchCriteria = function (){
        return searchCriteria;
    };
    model.getSearchResult = function (){
        return searchResult;
    };
    model.resetSearchResult = function (){
        searchResult = null;
    };
    model.resetSearchCriteria = function (){
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.ascending = true;
    };
    // Initialize search criteria when opening use case from menu.
    model.resetSearchCriteria();

    model.queryCertificates = function(page){
        var deferred = $q.defer();
        var options = {
            simulationDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            certificateType: searchCriteria.certificateType,
            certificateId: searchCriteria.certificateId,
            offset: CommonHelper.getOffset(page),
            count: CONSTANTS.rowsPerPage,
            sortOrder: searchCriteria.ascending? 'A' : 'D',
            sortColumn: searchCriteria.sortCol,
            language: CommonHelper.getLanguageCode($translate.use())
        };
        var result = QueryCertificate.queryCertificates(options, function () {
            searchResult = {};
            searchResult.totalItems = result.count;
            searchResult.certificates = result.items;
            searchResult.currentPage= page;
            deferred.resolve(searchResult);
        }, function(error){
            deferred.reject(error);
        });
        return deferred.promise;
    };

}).service('CertificateTypeModel', function($q, QueryCertificate){
    var model = this;
    model.queryCertificateTypes = function(){
        var deferred = $q.defer();
        QueryCertificate.queryCertificateTypes(function(certificateTypes){
            deferred.resolve(certificateTypes);
        }, function(error){
            deferred.reject(error);
        });
        return deferred.promise;
    };
});


// WEBPACK FOOTER //
// ./app/taric/certificate/shared/certificate-model.js